import { render, staticRenderFns } from "./fivesTableCellDop.vue?vue&type=template&id=9cbb48f0"
import script from "./fivesTableCellDop.vue?vue&type=script&lang=js"
export * from "./fivesTableCellDop.vue?vue&type=script&lang=js"
import style0 from "./fivesTableCellDop.vue?vue&type=style&index=0&id=9cbb48f0&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports